import React from 'react';
import './index.scss';
const ErrorPagesWrapper = ({ children, type }) => {
  return <div className={`error-main error-${type}`}>{children}</div>;
};

export default ErrorPagesWrapper;
